export function renderAdminV2WorkspaceActionConfirmationText(params: {
  text: string;
  currentToolName: string;
  targetToolName?: string | null;
}) {
  return params.text.replace(
    /\{(currentToolName|targetToolName)\}/g,
    (_match, token: 'currentToolName' | 'targetToolName') => {
      if (token === 'currentToolName') return params.currentToolName;
      if (!params.targetToolName) {
        throw new Error(
          'Workspace action confirmation requires a published target Tool name.'
        );
      }
      return params.targetToolName;
    }
  );
}
